// Type-safe mapping from CHIRP citation type to core citation type
const mapChirpCitationTypeToCore = chirpType => {
  switch (chirpType) {
    case 'APP':
      return 'APP';
    case 'CRM':
      return 'CRM';
    case 'WEBSITE':
      return 'WEBSITE';
    default:
      // Handle unhandledEnumCase or any unknown types by defaulting to 'APP'
      return 'APP';
  }
};

// Type-safe mapping from CHIRP citation to core citation
export const mapChirpCitationToCitationCore = chirpCitation => {
  let feedback;
  if (chirpCitation.feedback) {
    feedback = {
      polarity: chirpCitation.feedback.polarity,
      tags: chirpCitation.feedback.tags,
      comment: chirpCitation.feedback.comment
    };
  }
  return {
    id: chirpCitation.id,
    title: chirpCitation.title,
    retrievedDate: chirpCitation.retrievedDate,
    sourceName: chirpCitation.sourceName,
    metadata: chirpCitation.metadata,
    type: mapChirpCitationTypeToCore(chirpCitation.type),
    feedback
  };
};